var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorizeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2296",
    "data-name": "Group 2296",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.174,
    height: 27.174,
    viewBox: "0 0 27.174 27.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M0,0H27.174V27.174H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M22.248,14.587a1.133,1.133,0,0,1,1.132,1.132v6.793a1.133,1.133,0,0,1-1.132,1.132H4.132A1.133,1.133,0,0,1,3,22.513V15.719a1.133,1.133,0,0,1,1.132-1.132Zm-1.132,2.264H5.264V21.38H21.116ZM13.19,1A5.661,5.661,0,1,1,7.529,6.661,5.662,5.662,0,0,1,13.19,1Zm1.132,2.264H12.058V5.528H9.793V7.793h2.264v2.266h2.264V7.792h2.264V5.529H14.322Z",
    transform: "translate(0.397 0.132)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizeIcon);
export default __webpack_public_path__ + "static/media/authorize-icon.3e527d5114004e0161f1925243de804d.svg";
export { ForwardRef as ReactComponent };